import React from "react";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const handleEmailClick = () => {
    const email = "info@devananta.com";
    const subject = "Inquiry from Website";
    const body = "";

    const mailtoLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
      email
    )}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.open(mailtoLink, "_blank");
  };

  return (
    <footer className="w-full bg-black border-t border-white">
      <div className="mx-auto max-w-8xl py-2 lg:px-0 px-4 sm:px-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 justify-center text-center lg:text-left">
          <div className="space-y-4 flex flex-col items-start lg:items-center">
            <div className="flex items-center gap-3 mt-3">
              <img
                src="/logo.png"
                alt="Devananta R&D"
                className="w-16 h-12 hover:scale-105 transition-transform duration-300"
              />
              <div>
                <h2 className="text-2xl font-bold bg-gradient-to-r from-cyan-500 to-blue-500 bg-clip-text text-transparent">
                  Devananta R&D
                </h2>
                <p className="text-sm text-cyan-400 font-semibold">
                  Powering Tomorrow's World
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-3 flex flex-col items-start lg:items-center">
            <h3 className="text-white font-semibold text-lg">Contact Us</h3>
            <div className="space-y-4">
              <div className="flex flex-col xl:flex-row items-start lg:items-center justify-center sm:justify-start gap-3 xl:gap-8 ">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-green-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <svg
                      className="w-4 h-4 text-white"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                    </svg>
                  </div>
                  <span className="text-gray-300 text-md">+91 8210152465</span>
                </div>

                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-cyan-600 rounded-full flex items-center justify-center flex-shrink-0 cursor-pointer" 
                    onClick={handleEmailClick}>
                    <svg
                      className="w-4 h-4 text-white"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                    </svg>
                  </div>
                  <button
                    onClick={handleEmailClick}
                    className="text-gray-300 text-md hover:text-cyan-400 transition-colors duration-300 cursor-pointer"
                  >
                    info@devananta.com
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-4 flex flex-col items-start lg:items-center mb-2">
            <h3 className="text-white font-semibold text-lg">
              Follow Our Innovation
            </h3>
            <div className="flex items-center gap-3 flex-wrap justify-center lg:justify-start">
              {[
                {
                  name: "Twitter",
                  color: "bg-blue-400 hover:bg-blue-500",
                  icon: (
                    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                  ),
                  url: "#",
                },
                {
                  name: "LinkedIn",
                  color: "bg-blue-700 hover:bg-blue-800",
                  icon: (
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  ),
                  url: "https://www.linkedin.com/company/devananta-r-d/",
                },
                {
                  name: "YouTube",
                  color: "bg-red-600 hover:bg-red-700",
                  icon: (
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                  ),
                  url: "#",
                },
              ].map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`w-10 h-10 rounded-full ${social.color} flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-lg`}
                  title={social.name}
                >
                  <svg
                    className="w-5 h-5 text-white"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    {social.icon}
                  </svg>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 bg-stone-900/50">
        <div className="mx-auto max-w-7xl px-8 py-2">
          <div className="flex flex-col lg:flex-row items-center justify-center gap-4">
            <div className="flex items-center gap-6 text-sm text-gray-400">
              <span>
                © {currentYear} by Devananta R&D. All rights reserved.
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
